import Cookies from "js-cookie";

function setCookie(key, params, expires_at) {
  expires_at
    ? Cookies.set(key, params, {
        expires: expires_at,
      })
    : Cookies.set(key, params);
}

function getCookie(key) {
  return Cookies.get(key);
}

function removeCookie(key) {
  Cookies.remove(key);
}

export default {
  setCookie,
  getCookie,
  removeCookie,
};
